export type ExpenseItemNumber = string | number | null;

export interface ExpenseItem {
  client_id?: string;
  id?: number | null;
  name: string;
  quantity: string | number;
  unit_price?: ExpenseItemNumber;
  total_price?: ExpenseItemNumber;
  tax_amount?: ExpenseItemNumber;
  currency?: string | null;
  metadata?: {
    confidence?: number | null;
    product_code?: string | null;
    [key: string]: unknown;
  } | null;
}

export interface ExpenseItemPayload {
  id?: number;
  name: string;
  quantity: number;
  unit_price: number | null;
  total_price: number | null;
  tax_amount: number | null;
  currency: string;
  metadata?: ExpenseItem["metadata"];
}

const textValue = (value: ExpenseItemNumber | undefined, fallback = ""): string =>
  value === null || value === undefined ? fallback : String(value);

export const createBlankExpenseItem = (
  currency = "CAD",
  clientId: string | number = Date.now()
): ExpenseItem => ({
  client_id: `manual-${clientId}`,
  id: null,
  name: "",
  quantity: "1",
  unit_price: "",
  total_price: "",
  tax_amount: "",
  currency,
  metadata: {},
});

export const mapExpenseItems = (
  items: ExpenseItem[] = [],
  defaultCurrency = "CAD"
): ExpenseItem[] =>
  items.map((item, index) => ({
    client_id: item.id ? `stored-${item.id}` : `draft-${index}`,
    id: item.id ?? null,
    name: item.name ?? "",
    quantity: textValue(item.quantity, "1"),
    unit_price: textValue(item.unit_price),
    total_price: textValue(item.total_price),
    tax_amount: textValue(item.tax_amount),
    currency: item.currency || defaultCurrency,
    metadata: item.metadata ?? null,
  }));

const optionalNumber = (value: ExpenseItemNumber | undefined): number | null =>
  value === "" || value === null || value === undefined ? null : Number(value);

export const buildExpenseItemsPayload = (
  items: ExpenseItem[],
  defaultCurrency = "CAD"
): ExpenseItemPayload[] =>
  items.map((item) => ({
    ...(item.id ? { id: Number(item.id) } : {}),
    name: item.name.trim(),
    quantity: optionalNumber(item.quantity) ?? 1,
    unit_price: optionalNumber(item.unit_price),
    total_price: optionalNumber(item.total_price),
    tax_amount: optionalNumber(item.tax_amount),
    currency: (item.currency || defaultCurrency).toUpperCase(),
    metadata: item.metadata ?? null,
  }));
